import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@env';
import { registerLicense } from '@syncfusion/ej2-base';
import { isMsalBridgeResponse } from './app/core/services/authentication/msal-auth-response';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NDaF5cWWtCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1fcXRXR2dcUkB2XEE=');

if (environment.production) {
	enableProdMode();
}

// MSAL's loginPopup brings Microsoft's response back to this app at the same redirectUri, in the popup.
// Bootstrapping there would show the app inside the popup and let Angular's initial navigation strip the
// response before MSAL reads it. isMsalBridgeResponse explains why window.opener can't be used to detect this.
const isMsalAuthPopup: boolean = isMsalBridgeResponse(window.location.hash, window.location.search);

if (isMsalAuthPopup) {
	// MSAL v5 popups complete through the redirect bridge, which hands the response to the main window over a BroadcastChannel
	import('@azure/msal-browser/redirect-bridge')
		.then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
		.catch(err => console.error(err));
} else {
	platformBrowserDynamic()
		.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
		.catch(err => console.error(err));
}
